import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import {
    Component,
    computed,
    inject,
    input,
    model,
    output,
    signal,
} from "@angular/core";
import { InfoService, StoreMenuDto } from "@malirang/api-client";
import { ProductType } from "@malirang/common";
import {
    Icon,
    IconButton,
    Menu,
    MenuOption,
    ToastService,
} from "@malirang/front-share";
import { StoreMenuFormComponent } from "../store-menu-form/store-menu-form.component";

@Component({
    selector: "app-store-menu-item",
    templateUrl: "./store-menu-item.component.html",
    styleUrls: ["./store-menu-item.component.css"],
    imports: [
        Icon,
        CommonModule,
        IconButton,
        StoreMenuFormComponent,
        CdkMenuModule,
        Menu,
        MenuOption,
        CdkDrag,
        CdkDragHandle,
    ],
})
export class StoreMenuItemComponent {
    readonly service = inject(InfoService);
    readonly toastService = inject(ToastService);

    menus = input.required<StoreMenuDto>();
    type = input.required<keyof typeof ProductType>();
    currentItem = computed(() => this.menus()[this.type()]);

    refresh = output<void>();
    isUpdate = signal(false);
    formValue = model<string>("");

    cancel() {
        this.isUpdate.set(false);
    }

    handleUpdate() {
        this.isUpdate.set(true);
        this.formValue.set(this.currentItem()?.name || "");
    }

    submit() {
        if (!this.formValue()) {
            this.toastService.error("메뉴 이름을 입력해주세요.");
            return;
        }

        this.service
            .infoControllerUpdateStoreMenuV1({
                body: {
                    ...this.menus(),
                    [this.type()]: {
                        name: this.formValue(),
                        order: this.currentItem()?.order || 0,
                        type: this.type(),
                    },
                },
            })
            .subscribe({
                next: () => {
                    this.isUpdate.set(false);
                    this.refresh.emit();
                    this.toastService.success("메뉴가 수정되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }
}
